"use client"

import React from "react"
import Link from "next/link"

import { ReducedProductData } from "@/lib/storefront/product/product"
import { storeFactFinderSessionAttribution } from "@/lib/tracking/factfinder-session-attribution"
import { trackFFProductClick } from "@/lib/tracking/tracking-helper"

export default function AccountProductTrackingLink(props: {
  product: ReducedProductData
  href: string
  trackingList: string
  searchTerm?: string
  position?: number
  prefetch?: boolean
  className?: string
  children: React.ReactNode
}) {
  return (
    <Link
      href={props.href}
      prefetch={props.prefetch}
      className={props.className}
      onClick={() => {
        storeFactFinderSessionAttribution({
          productId: props.product.id,
          trackingList: props.trackingList,
          searchTerm: props.searchTerm ?? props.trackingList,
          position: props.position,
        })
        trackFFProductClick(
          props.product,
          props.trackingList,
          props.position ?? 1,
          props.searchTerm ?? props.trackingList,
          props.product.ffCampaignId
        )
      }}
    >
      {props.children}
    </Link>
  )
}
